import { Directive } from '@angular/core';

@Directive({
    selector: '[laDocumentBuilderDocument]',
    standalone: false
})
export class DocumentBuilderDocumentDirective {}

@Directive({
    selector: '[laDocumentBuilderPanelTop]',
    standalone: false
})
export class DocumentBuilderPanelTopDirective {}

@Directive({
    selector: '[laDocumentBuilderPanelBottom]',
    standalone: false
})
export class DocumentBuilderPanelBottomDirective {}
